import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome4Line = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_134_1662)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.8 2.65C11.5111 2.11667 12.4889 2.11667 13.2 2.65L20.2 7.9C20.7036 8.27771 21 8.87049 21 9.5V19C21 20.1046 20.1046 21 19 21H14.1C13.4925 21 13 20.5075 13 19.9V14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V19.9C11 20.5075 10.5075 21 9.9 21H5C3.89543 21 3 20.1046 3 19V9.5C3 8.87049 3.29639 8.27771 3.8 7.9L10.8 2.65ZM12 4.25L5 9.5V19H9V14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14V19H19V9.5L12 4.25Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_134_1662",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgHome4Line;
